/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.share', function (el) {
        var popupCenter = function (url, title, w, h) {
            var dualScreenLeft = window.screenLeft !== undefined
                ? window.screenLeft
                : window.screenX;
            var dualScreenTop = window.screenTop !== undefined
                ? window.screenTop
                : window.screenY;
            var width = window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                    ? document.documentElement.clientWidth
                    : screen.width;
            var height = window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                    ? document.documentElement.clientHeight
                    : screen.height;
            var systemZoom = width / window.screen.availWidth;
            var left = (width - w) / 2 / systemZoom + dualScreenLeft;
            var top = (height - h) / 2 / systemZoom + dualScreenTop;
            var newWindow = window.open(url, title, "\n\t\tscrollbars=yes,\n\t\twidth=" + w / systemZoom + ", \n\t\theight=" + h / systemZoom + ", \n\t\ttop=" + top + ", \n\t\tleft=" + left + "\n\t\t");
            if (window.focus) {
                newWindow.focus();
            }
        };
        el.addEventListener('click', function (e) {
            e.preventDefault();
            popupCenter(el.getAttribute('href'), '', 550, 500);
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
